import { URI } from '@/config/config'

export default async ({ rootState }) => {
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    }
  }

  try {
    const userLoginInfoResult = await fetch(`${URI}control-panel/system/version`, opts)
    const resultJson = await userLoginInfoResult.json()

    if (userLoginInfoResult.status !== 200) {
      return Promise.reject(resultJson)
    }

    return resultJson.version
  } catch (error) {
    return Promise.reject(error)
  }
}